<script>
    import {onMount} from "svelte";
    import {navigate} from "svelte-navigator";
    import {slide} from 'svelte/transition'
    import Modal from 'svelte-simple-modal';
    import AddToHomeScreen from 'a2hs.js';
    import {convertDimensionsToDiameter, convertProductToUrl} from '../utils/webHelper.ts';
    import {storedInput, storedSelections, storedResult} from '../global.ts';

    import QueryHandler from '../Components/QueryHandler.svelte';
    import InformationContent from '../Components/InformationContent.svelte';
    import language from '../language/da_DK.json';
    import '../../public/global.css';

    let input = {};
    let queryHandler;
    let selections;
    let currentType;
    let selectedOption;
    let show = false;
    let inputIsEmpty;
    let enableInsulationClass = false;
    let enableTemperature = false;

    let types = [
        {id: "rectangular", label: language.rectangular, imgSrc: "/images/rectangular_yellow.svg"},
        {id: "circular", label: language.circular, imgSrc: "/images/circular_yellow.svg"},
        {id: "pipe", label: language.pipe, imgSrc: "/images/pipe_yellow.svg"},
    ];

    let placement = [
        {id: "indoors_heated", label: language.heatedRoom, imgSrc: "/images/indoors_heated_yellow.svg"},
        {id: "indoors_unheated", label: language.unheatedRoom, imgSrc: "/images/indoors_unheated_yellow.svg"},
        {id: "outdoors", label: language.outdoors, imgSrc: "/images/outdoors_yellow.svg"},
    ];

    let options = [{id: "bearing", label: language.bearing, imgSrc: "/images/bearing_white.svg"}];

    let insulationClass = {id: "insulationClass", label: language.insulationClass, imgSrc: "/images/insulation_class_white.svg"};
    let temperature = {id: "temperature", label: language.temperature, imgSrc: "/images/temp_white.svg"};

    const showMenu = async () => {
        show = !show;
    };

    function collapseMenu() {
        selectedOption = '';
        show = false;
    }

    function clear() {
        for (const [key] of Object.entries(input)) {
            if (key !== 'type' && key !== 'placement') delete input[key];
        }
        input = input;
        localStorage.clear();
        document.getElementById('result-button').disabled = true;
        inputIsEmpty = true;
        show = false;
        enableInsulationClass = false;
        enableTemperature = false;
    }

    async function handleType(type) {
        input = {
            ...input,
            type: type
        };

        if (input.type.id !== currentType.id) {
            selections = await queryHandler.getSelections(input.type.label);
            clear();
        }

        if (input.type.id === 'circular' || input.type.id === 'pipe') {
            options = options.filter((o) => o.id !== 'width' && o.id !== 'height');
            let circularObject = {id: "diameter", label: language.diameter, imgSrc: "/images/diameter_white.svg"};
            if (currentType.id === 'rectangular') {
                if (!options.some(o => o.id === circularObject.id)) {
                    options.unshift(circularObject);
                    options = options;
                }
            }
        } else {
            options = options.filter((o) => o.id !== 'diameter');
            if (currentType.id !== 'rectangular') {
                addWidthAndHeightToOptions();
            }
        }
        currentType = type;
    }

    function addWidthAndHeightToOptions() {
        let width = {id: "width", label: language.width, imgSrc: "/images/width_white.svg"};
        let height = {id: "height", label: language.height, imgSrc: "/images/height_white.svg"};
        options.unshift(width, height);
        options = options;
    }

    function handleSelectedOption(option) {
        selectedOption = option;
    }

    function handlePlacementInput(placement) {
        validateChange(placement);
        input = {
            ...input,
            placement: placement
        }
        validateInput();
    }

    function handleSelectedWidthInput(width) {
        validateChange(width);
        input = {
            ...input,
            width: width
        }
        validateDimensions();
        storedInput.set(input);
        validateInput();
        collapseMenu();
    }

    function handleSelectedHeightInput(height) {
        validateChange(height);
        input = {
            ...input,
            height: height
        }
        validateDimensions();
        storedInput.set(input);
        validateInput();
        collapseMenu();
    }

    function handleSelectedDiameterInput(diameter) {
        validateChange(diameter);
        input = {
            ...input,
            diameter: diameter
        }
        storedInput.set(input);
        validateInput();
        collapseMenu();
    }

    function handleSelectedBearingInput(bearing) {
        validateChange(bearing);
        input = {
            ...input,
            bearing: bearing
        }
        storedInput.set(input);
        validateInput();
        collapseMenu();
    }

    async function handleSelectedInsulationClassInput(insulationClass) {
        if ($storedInput.insulationClass !== insulationClass) {
            delete input.temp;
        }

        input = {
            ...input,
            insulationClass: insulationClass
        }
        storedInput.set(input);

        await queryHandler.getTemperatures(input.type.label, input.placement.label, input.diameter.diameter, input.bearing.bearing, input.insulationClass.insulation_class).then((data) => {
            selections = {
                ...selections,
                temps: data
            }
            storedSelections.set(selections);
        });
        await validateInput();
        collapseMenu();
    }

    function handleSelectedTempInput(temp) {
        input = {
            ...input,
            temp: temp
        }
        storedInput.set(input);
        validateInput();
        collapseMenu();
    }

    async function validateInput() {
        enableInsulationClass = insulationClassValid();
        enableTemperature = temperatureValid();

        if (insulationClassValid() && !temperatureValid()) {
            await queryHandler.getInsulationClasses(input.type.label, input.placement.label, input.diameter.diameter, input.bearing.bearing).then((data) => {
                selections = {
                    ...selections,
                    insulationClasses: data
                }
                storedSelections.set(selections);
            });
        }

        document.getElementById('result-button').disabled = !resultButtonValid();
        inputIsEmpty = isEmpty();
    }

    function validateChange(value) {
        if (`${$storedInput}.${value}` !== value) {
            delete input.insulationClass;
            delete input.temp;
        }
    }

    function validateDimensions() {
        if (input?.height && input?.width) {
            input = {
                ...input,
                diameter: convertDimensionsToDiameter(input?.height.height, input?.width.width)
            }
        }
    }

    function insulationClassValid() {
        if (input.type.id === 'rectangular') {
            return (input.type && input.placement && input.height && input.width && input.bearing);
        } else {
            return (input.type && input.placement && input.diameter && input.bearing);
        }
    }

    function temperatureValid() {
        return (input.insulationClass);
    }

    function resultButtonValid(){
        return (input.temp);
    }

    function isEmpty() {
        return !(input.width || input.height || input.diameter || input.bearing || input.insulationClass || input.temp);
    }

    async function handleSubmit() {
        await queryHandler.getResults(input)
            .then((data) => {
                let result = data.map((r) => {
                    if (r.name.includes('ISOVER')) {
                        let url = convertProductToUrl(r.name);
                        return {
                            ...r,
                            imgSrc: "/images/isover_logo.svg",
                            url: `https://www.saint-gobain.dk/produkt/${url}`
                        }
                    }
/*                    else if (r.name.includes('Kaimann')) {
                        return {
                            ...r,
                            imgSrc: "/images/kaimann_logo.svg",
                            url: 'https://www.kaimann.com/da'
                        }
                    }*/
                })
                storedResult.set(result);
            })
            .then(() => {
                navigate("/result");
                document.body.scrollIntoView();
            })
    }

    function setPreviousInputValues() {

        types.map((t) => {
            if (t.id === $storedInput.type.id) {
                input = {
                    ...input,
                    type: t
                }
            }
        })

        if ($storedInput.type.id === 'rectangular') {
            options = options.filter((o) => o.id !== 'diameter');
            addWidthAndHeightToOptions();
            selections.widths.map((w) => {
                if (w.width === $storedInput.width.width) {
                    input = {
                        ...input,
                        width: w
                    }
                }
            })

            selections.heights.map((h) => {
                if (h.height === $storedInput.height.height) {
                    input = {
                        ...input,
                        height: h
                    }
                }
            })

            input = {
                ...input,
                diameter: $storedInput.diameter
            }

        } else if ($storedInput.type.id === 'circular' || $storedInput.type.id === 'pipe') {
            options = options.filter((o) => o.id !== 'width' && o.id !== 'height');
            let circularObject = {id: "diameter", label: language.diameter, imgSrc: "/images/diameter_white.svg"};
            options.unshift(circularObject);
            options = options;

            selections.diameters.map((d) => {
                if (d.diameter === $storedInput.diameter.diameter) {
                    input = {
                        ...input,
                        diameter: d
                    }
                }
            })
        }

        placement.map((p) => {
            if (p.id === $storedInput.placement.id) {
                input = {
                    ...input,
                    placement: p
                }
            }
        })

        selections.bearings.map((b) => {
            if (b.bearing === $storedInput.bearing.bearing) {
                input = {
                    ...input,
                    bearing: b
                }
            }
        })

        selections.insulationClasses.map((i) => {
            if (i.insulation_class === $storedInput.insulationClass.insulation_class) {
                input = {
                    ...input,
                    insulationClass: i
                };
            }
        });

        selections.temps.map((t) => {
            if (t.temp === $storedInput.temp.temp) {
                input = {
                    ...input,
                    temp: t
                }
            }
        })
    }

    onMount(async () => {
        inputIsEmpty = true;

        AddToHomeScreen({
            brandName: "HVAC",
            fontFamily: "Ubuntu, sans-serif",
            logoImage: "<img src='/images/app_icon.svg' alt='app icon'/>"
        });

        //To prevent error on reload of app with incomplete inputs
        const onMountCheck = $storedInput !== null && (($storedInput.type.id === 'rectangular' && Object.keys($storedInput).length > 7) || ($storedInput.type.id !== 'rectangular' && Object.keys($storedInput).length > 5));

        if (onMountCheck) {
            enableInsulationClass = true;
            enableTemperature = true;
            currentType = $storedInput.type;
            selections = $storedSelections;
            setPreviousInputValues();
            await validateInput();
        }
        else {
            clear();

            input = {
                type: types[0],
                placement: placement[0]
            }

            currentType = types[0];

            if (currentType.id === 'rectangular') {
                addWidthAndHeightToOptions();
            }
            selections = await queryHandler.getSelections(currentType.label);
        }
    });
</script>

<QueryHandler bind:this={queryHandler}/>
<div class="container">
    <section class="header">
        <div class="titles">
            <h1>{language.title}</h1>
            <h2>{language.chooseParams}</h2>
        </div>
        <Modal styleContent={{ backgroundColor: '#F6F3F0', borderRadius: '0.3125rem'}}>
            <InformationContent/>
        </Modal>
    </section>
    <section>
        <form on:submit|preventDefault={handleSubmit}>
            <section class="type-section">
                {#each types as type}
                    <div class={input.type === type ? "active-type" : "type-wrapper not-active" }
                         on:click={() => {handleType(type)}}>
                        <img src={type.imgSrc} alt="type" class="icon-image"/>
                        <div class="type-span-wrapper">
                            <span>{type.label}</span>
                        </div>
                    </div>
                {/each}
            </section>
            <section class="surrounding-section">
                {#each placement as place}
                    <div class={input.placement === place ? "active-heating" : "surrounding-wrapper not-active"}
                         on:click={() => { handlePlacementInput(place)}}>
                        <img src={place.imgSrc} alt="surroundings" class="icon-image"/>
                        <div class="placement-span-wrapper">
                            <span>{place.label}</span>
                        </div>
                    </div>
                {/each}
            </section>
            {#if !inputIsEmpty}
                <section class="clear-input-section">
                    <span on:click={clear}>{language.clear}</span>
                </section>
            {/if}
            <section class="menu-section">
                {#each options as option }
                    <div class="menu-item" id={option.id} on:click={() => handleSelectedOption(option)}>
                        <div class="menu-item-content" on:click={showMenu}>
                            <img src={option.imgSrc} alt="options" class="menu-icon"/>
                            <div class="option-text">
                                <span class="option-header-span">{option.label}</span>
                            </div>
                            <div class="selected-menu-item-span">
                                {#if input?.width && option.id === 'width'}
                                    <span class="selected-input">{input.width.width} {language.mm}</span>
                                {:else if input?.height && option.id === 'height'}
                                    <span class="selected-input">{input.height.height} {language.mm}</span>
                                {:else if input?.diameter && option.id === 'diameter'}
                                    <span class="selected-input">{input.diameter.diameter} {language.mm}</span>
                                {:else if input?.bearing && option.id === 'bearing'}
                                    <span class="selected-input">{input.bearing.bearing}</span>
                                {/if}
                            </div>
                            <img src="/images/down_button.svg" alt="down-button"
                                 class={selectedOption === option && show ? "selected-menu-item arrow-down-button" : "arrow-down-button" }/>
                        </div>
                        {#if show && selectedOption === option}
                            <section class="menu-sub-items-wrapper" transition:slide={{ duration: 250 }}>
                                <ul class="menu-items">
                                    {#if selectedOption.id === "width"}
                                        {#each selections.widths as width}
                                            <li on:click={() => handleSelectedWidthInput(width)}>
                                                <span>{width.width} {language.mm}</span>
                                                {#if input.width === width}
                                                    <img src="/images/checkmark.svg" alt="checkmark icon"/>
                                                {/if}
                                            </li>
                                        {/each}
                                    {:else if selectedOption.id === "height"}
                                        {#each selections.heights as height}
                                            <li on:click={() => handleSelectedHeightInput(height)}>
                                                <span>{height.height} {language.mm}</span>
                                                {#if input.height === height}
                                                    <img src="/images/checkmark.svg" alt="checkmark icon"/>
                                                {/if}
                                            </li>
                                        {/each}
                                    {:else if selectedOption.id === "diameter"}
                                        {#each selections.diameters as diameter}
                                            <li on:click={() => handleSelectedDiameterInput(diameter)}>
                                                <span>{diameter.diameter} {language.mm}</span>
                                                {#if input.diameter === diameter}
                                                    <img src="/images/checkmark.svg" alt="checkmark icon"/>
                                                {/if}
                                            </li>
                                        {/each}
                                    {:else if selectedOption.id === "bearing"}
                                        {#each selections.bearings as bearing}
                                            <li on:click={() => handleSelectedBearingInput(bearing)}>
                                                <span>{bearing.bearing}</span>
                                                {#if input.bearing === bearing}
                                                    <img src="/images/checkmark.svg" alt="checkmark icon"/>
                                                {/if}
                                            </li>
                                        {/each}
                                    {/if}
                                </ul>
                            </section>
                        {/if}
                    </div>
                {/each}
                <div class={enableInsulationClass ? "active-item menu-item" : "disabled-item menu-item"}
                     id={insulationClass.id} on:click={() => handleSelectedOption(insulationClass)}>
                    <div class="menu-item-content" on:click={showMenu}>
                        <img src={insulationClass.imgSrc} alt="options" class="menu-icon"/>
                        <div class="option-text">
                            <span class="option-header-span">{language.insulationClass}</span>
                        </div>
                        <div class="selected-menu-item-span">
                            {#if input?.insulationClass}
                                <span class="selected-input"> {input.insulationClass.insulation_class}</span>
                            {/if}
                        </div>
                        <img src="/images/down_button.svg" alt="down-button"
                             class={selectedOption === insulationClass && show ? "selected-menu-item arrow-down-button" : "arrow-down-button" }/>
                    </div>
                    {#if show && selectedOption === insulationClass}
                        <section class="menu-sub-items-wrapper" transition:slide={{ duration: 250 }}>
                            <ul class="menu-items">
                                {#each selections?.insulationClasses as insulationClass}
                                    <li on:click={handleSelectedInsulationClassInput(insulationClass)}>
                                        <span>{insulationClass.insulation_class}</span>
                                        {#if input.insulationClass === insulationClass}
                                            <img src="/images/checkmark.svg" alt="checkmark icon"/>
                                        {/if}
                                    </li>
                                {/each}
                            </ul>
                        </section>
                    {/if}
                </div>

                <div class={enableTemperature ? "active-item menu-item" : "disabled-item menu-item"} id={temperature.id}
                     on:click={() => handleSelectedOption(temperature)}>
                    <div class="menu-item-content" on:click={showMenu}>
                        <img src={temperature.imgSrc} alt="options" class="menu-icon"/>
                        <div class="option-text">
                            <span class="option-header-span">{language.temperature}</span>
                        </div>
                        <div class="selected-menu-item-span">
                            {#if input?.temp}
                                <span class="selected-input"> {input.temp.temp} {language.celsius}</span>
                            {/if}
                        </div>
                        <img src="/images/down_button.svg" alt="down-button"
                             class={selectedOption === temperature && show ? "selected-menu-item arrow-down-button" : "arrow-down-button" }/>
                    </div>
                    {#if show && selectedOption === temperature}
                        <section class="menu-sub-items-wrapper" transition:slide={{ duration: 250 }}>
                            <ul class="menu-items">
                                {#each selections?.temps as temperature}
                                    <li on:click={() => handleSelectedTempInput(temperature)}>
                                        <span>{temperature.temp} {language.celsius}</span>
                                        {#if input.temp === temperature}
                                            <img src="/images/checkmark.svg" alt="checkmark icon"/>
                                        {/if}
                                    </li>
                                {/each}
                            </ul>
                        </section>
                    {/if}
                </div>

            </section>

            <button id="result-button" type="submit" class="show-result-button"
                    disabled="disabled">{language.showResult}
            </button>

        </form>
    </section>
</div>

<style>
</style>